/* globals $ */
import { registerClass } from 'libs/ComponentLoader'
import debounce from 'debounce'

import { MID_TABLET } from '_global/js/constants'

import './styles.scss'

class HeroCarousel {
  constructor (element) {
    this.$el = $(element)
    this.$carousel = this.$el.find('.heroCarousel-carousel')
    this.$playButton = this.$el.find('.heroCarousel-playButton')
    this.$pagination = this.$el.find('.heroCarousel-pagination')
    this.$thumbnail = this.$el.find('.heroCarousel-thumbWrapper')
    this.breakpoint = 1150

    this.initSlick()
    this.setActiveThumbnail()
    this.$playButton.on('click', e => {
      this.controlAutoplay()
    })
    this.$thumbnail.on('click', e => {
      this.showSlide(e)
    })
  }
  initSlick () {
    this.$carousel.slick({
      autoplay: true,
      dots: false,
      arrows: false,
      rows: 0, // https://github.com/kenwheeler/slick/issues/3149
      speed: 500,
      fade: true,
      cssEase: 'linear',
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: this.breakpoint,
          settings: {
            dots: true,
            adaptiveHeight: true
          }
        }
      ]
    })

    this.$carousel.on('afterChange', (event, slick, currentSlide) => {
      this.setSlideDots()
    })
    $(window).on('resize', debounce(() => {
      this.setSlideDots()
    }, 50))
    this.setSlideDots()
  }
  setActiveThumbnail () {
    const activeClass = 'heroCarousel-thumbWrapper--active'

    this.$carousel.on('beforeChange', (event, slick, currentSlide, nextSlide) => {
      this.$thumbnail.removeClass(activeClass)
      this.$pagination.find(`[data-slide-number="${nextSlide}"]`).addClass(activeClass)
    })
    this.$thumbnail.removeClass(activeClass)
    this.$pagination.find(`[data-slide-number="0"]`).addClass(activeClass)
  }
  controlAutoplay () {
    const mode = this.$playButton.data('mode')
    const $playPath = this.$playButton.find('#play')
    const $pausePath = this.$playButton.find('#pause')

    if (mode === 'play') {
      this.$playButton
        .attr('aria-label', $pausePath.data('desc'))
        .attr('title', $pausePath.data('desc'))
        .data('mode', $pausePath.attr('id'))
        .attr('data-mode', $pausePath.attr('id')) // to also change visible val in dom

      $pausePath.show()
      $playPath.hide()
      this.$carousel.slick('slickPlay')
    } else {
      this.$playButton
        .attr('aria-label', $playPath.data('desc'))
        .attr('title', $playPath.data('desc'))
        .data('mode', $playPath.attr('id'))
        .attr('data-mode', $playPath.attr('id')) // to also change visible val in dom

      $playPath.show()
      $pausePath.hide()
      this.$carousel.slick('slickPause')
    }
  }
  showSlide (e) {
    const $self = $(e.target)
    const slideNumber = $self.data('slide-number')

    this.$carousel.slick('slickGoTo', slideNumber)
  }

  setSlideDots () {
    const mqMidTablet = window.matchMedia(MID_TABLET)

    if (mqMidTablet.matches) {
      let slideImageHeight = this.$carousel.find('.slick-current.slick-active').find('.heroCarousel-imageWrapper').height()
      if (slideImageHeight > 0) {
        slideImageHeight += 55
        this.$carousel.find('.slick-dots').css({
          top: 'auto',
          bottom: `${slideImageHeight}px`
        })
      } else {
        this.$carousel.find('.slick-dots').css({
          top: '',
          bottom: ''
        })
      }
    } else {
      this.$carousel.find('.slick-dots').css({
        top: '',
        bottom: ''
      })
    }
  }
}

registerClass('HeroCarousel', HeroCarousel)
